export const COLORS = {
  primary: '#00C689',
  primaryDark: '#00A873',
  secondary: '#020617',
  warning: '#F59E0B',
  success: '#00C689',
  danger: '#EF4444',
  bgBody: '#020617',
  bgApp: '#F8FAFC',
  bgSurface: '#FFFFFF',
  bgInput: '#F1F5F9',
  textMain: '#020617',
  textMuted: '#64748B',
  textLight: '#94A3B8',
  border: '#E2E8F0',
};